import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';

export const VACATION_HOME = {
  nickname: 'PRODUCTS.VACATION_HOME.shortname',
  LIST_OF_OBJECTS: ['houseAdditionalBuildings', 'houseWithContents'],
  properties: [
    {
      name: 'calculatedClientAge', key: 'CLIENT_AGE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.pattern(/^\d+$/)
      ]]
    },
    {
      name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.4', value: '4000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.6', value: '6000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.8', value: '8000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.12', value: '12000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.16', value: '16000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.20', value: '20000' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.25', value: '25000' },
        ]
      }
    },
    {
      name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.STANDARD', value: 'STANDARD' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.SUPER', value: 'SUPER' }
        ]
      }
    },
    {
      name: 'houseBuildingYear', key: 'BUILDING_YEAR', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.DATE,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        dateView: 'multi-years'
      }
    },
    {
      name: 'houseSquareMeters', key: 'SQUARE_METERS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.NUMBER,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'houseSumInsuredType',
      key: 'SUM_INSURED_TYPE',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      isFirstRiskSumInsuredCheck: true,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SUM_INSURED_TYPE.FULL_VALUE', value: 'FULL_VALUE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SUM_INSURED_TYPE.FIRST_RISK', value: 'FIRST_RISK' },
        ]
      }
    },
    { name: 'houseFirstRiskSumInsured', key: 'SUM_INSURED', group: 'INSURANCE_INFO' },
    {
      name: 'houseBuildingMaterials', key: 'BUILDING_MATERIALS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MATERIALS.WOOD', value: 'WOOD' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MATERIALS.CONCRETE', value: 'CONCRETE' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MATERIALS.MUR_AND_WOOD', value: 'MUR_AND_WOOD' },
        ]
      }
    },
    {
      name: 'wtcBuildingConstructionFactor', key: 'BUILDING_CONSTRUCTION_FACTOR', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]],
    },
    {
      name: 'houseOldestRenovationYear', key: 'HOUSE_OLDEST_RENOVATION_YEAR', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.DATE,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        dateView: 'multi-years'
      }
    },
    { name: 'houseSMFlatRoof', key: 'HOUSE_SM_FLAT_ROOF_TTFINANS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'buildingUnUsed', key: 'BUILDING_UNUSED_SQM', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_UNUSED_SQM.10', value: '10' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_UNUSED_SQM.20', value: '20' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_UNUSED_SQM.40', value: '40' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_UNUSED_SQM.60', value: '60' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_UNUSED_SQM.NO', value: 'NO' }
        ]
      }
    },
    {
      name: 'houseBuildingStandard', key: 'BUILDING_STANDARD', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_STANDARD.NORMAL', value: 'NORMAL' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_STANDARD.BETTER', value: 'BETTER' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_STANDARD.HIGH', value: 'HIGH' },
        ]
      }
    },
    {
      name: 'houseBuildingHasPower', key: 'HOUSE_BUILDING_HAS_POWER', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_HAS_POWER.NEWER_THAN_15_YEARS',
            value: 'NEWER_THAN_15_YEARS'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_HAS_POWER.OLDER_THAN_15_YEARS',
            value: 'OLDER_THAN_15_YEARS'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_HAS_POWER.NO_INSTALLED_POWER',
            value: 'NO_INSTALLED_POWER'
          }
        ]
      }
    },
    {
      name: 'housePipeSystem', key: 'HOUSE_PIPE_SYSTEM', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_PIPE_SYSTEM.NEWER_THAN_15_YEARS',
            value: 'NEWER_THAN_15_YEARS'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_PIPE_SYSTEM.OLDER_THAN_15_YEARS',
            value: 'OLDER_THAN_15_YEARS'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_PIPE_SYSTEM.NO_INSTALLED_WATER',
            value: 'NO_INSTALLED_WATER'
          }
        ]
      }
    },
    {
      name: 'houseSMAutomaticWaterStop', key: 'HOUSE_SM_AUTOMATIC_WATER_STOP', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SM_AUTOMATIC_WATER_STOP.WITHOUT_NOTIFICATION',
            value: 'WITHOUT_NOTIFICATION'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SM_AUTOMATIC_WATER_STOP.WITH_NOTIFICATION',
            value: 'WITH_NOTIFICATION'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SM_AUTOMATIC_WATER_STOP.NO',
            value: 'NO'
          }
        ]
      }
    },
    {
      name: 'houseNumberOfBathrooms', key: 'HOUSE_NUMBER_OF_BATHROOMS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_BATHROOMS.UP_TO_3_WET_ROOMS', value: '3-' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_BATHROOMS.4_WET_ROOMS', value: '4' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_BATHROOMS.5_AND_MORE_WET_ROOMS', value: '5+' },
        ]
      }
    },
    { name: 'houseIsRented', key: 'HOUSE_IS_RENTED', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_OWNER_PRIMARY.NOT_RENTED', value: 'NO' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_OWNER_PRIMARY.PARTIALLY_RENTED', value: 'PARTIAL' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_OWNER_PRIMARY.RENTED', value: 'YES' }
        ]
      },
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'houseSMBurglarAlarmConnected', key: 'HOUSE_SM_BURGAR_ALARM_CONNECTED', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SM_BURGAR_ALARM_CONNECTED.LOCAL_NOTIFICATION',
            value: 'LOCAL_NOTIFICATION'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SM_BURGAR_ALARM_CONNECTED.SECURITY_COMPANY_NOTIFICATION',
            value: 'SECURITY_COMPANY_NOTIFICATION'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SM_BURGAR_ALARM_CONNECTED.FIRE_ALARM_SECURITY_COMPANY_NOTIFICATION',
            value: 'FIRE_ALARM_SECURITY_COMPANY_NOTIFICATION'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SM_BURGAR_ALARM_CONNECTED.FIRE_ALARM_LOCAL_NOTIFICATION',
            value: 'FIRE_ALARM_LOCAL_NOTIFICATION'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SM_BURGAR_ALARM_CONNECTED.BURGLARY_FIRE_ALARM_LOCAL_NOTIFICATION',
            value: 'BURGLARY_FIRE_ALARM_LOCAL_NOTIFICATION'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SM_BURGAR_ALARM_CONNECTED.BURGLARY_FIRE_ALARM_SECURITY_COMPANY_NOTIFICATION',
            value: 'BURGLARY_FIRE_ALARM_SECURITY_COMPANY_NOTIFICATION'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SM_BURGAR_ALARM_CONNECTED.NO',
            value: 'NO'
          }
        ]
      }
    },
    {
      name: 'houseSMFireAlarmConnected', key: 'HOUSE_SM_FIRE_ALARM_CONNECTED_TTFINANS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SM_FIRE_ALARM_CONNECTED.INTERCONNECTED_SMOKE_DETECTORS',
            value: 'INTERCONNECTED_SMOKE_DETECTORS'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SM_FIRE_ALARM_CONNECTED.NO',
            value: 'NO'
          }
        ]
      }
    },
    {
      name: 'wtcHouseownerBasementDry', key: 'HOUSE_OWNER_BASEMENT_DRY', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_OWNER_BASEMENT_DRY.NO_BASEMENT', value: 'NO_BASEMENT' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_OWNER_BASEMENT_DRY.CRAWL_SPACE', value: 'CRAWL_SPACE' },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_OWNER_BASEMENT_DRY.BASEMENT_NOT_FURNISHED',
            value: 'BASEMENT_NOT_FURNISHED'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_OWNER_BASEMENT_DRY.BASEMENT_FURNISHED',
            value: 'BASEMENT_FURNISHED'
          },
          {
            key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_OWNER_BASEMENT_DRY.BASEMENT_PARTIALLY_FURNISHED',
            value: 'BASEMENT_PARTIALLY_FURNISHED'
          }
        ]
      }
    },
    {
      name: 'houseNumberOfResidents', key: 'HOUSE_NUMBER_OF_RESIDENTS', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_RESIDENTS.1', value: '1' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_RESIDENTS.2', value: '2' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_RESIDENTS.3', value: '3' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_RESIDENTS.4', value: '4' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_RESIDENTS.5', value: '5' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_RESIDENTS.6', value: '6' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_RESIDENTS.7', value: '7' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_NUMBER_OF_RESIDENTS.8_OR_MORE', value: '8_OR_MORE' },
        ]
      }
    },
    { name: 'houseRotAndAnimalDamage', key: 'HOUSE_ROT_AND_ANIMAL_DAMAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    { name: 'wtcWaterSecurity', key: 'WTC_WATER_SECURITY_TTFINANS', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]],
    },
    {
      name: 'houseWithContents', key: 'HOUSE_WITH_CONTENTS', group: 'INSURANCE_INFO',
      values: [
        { name: 'productSumInsured', key: 'SUM_INSURED', group: 'INSURANCE_INFO',
          inputType: INPUT_TYPES_CONFIG.NUMBER,
          HOUSE_CONTENT_SUM_INSURED_MIN_300000: true,
          validator: ['', [
            Validators.required,
            Validators.pattern(/^(?:3[0-9]{5}|[4-9]\d{5}|\d{7,})$/)
          ]]
        },
        {
          name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.STANDARD', value: 'STANDARD' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.SUPER', value: 'SUPER' }
            ]
          }
        },
        {
          name: 'deductible', key: 'DEDUCTIBLE', group: 'INSURANCE_INFO',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.4', value: '4000' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.6', value: '6000' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.8', value: '8000' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.DEDUCTIBLE.12', value: '12000' }
            ]
          }
        },
        {
          name: 'contentsType', key: 'CONTENTS_TYPE', group: 'INSURANCE_INFO',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            list: [
              {
                key: 'PROPERTIES_FORM.SELECT_LIST.CONTENTS_TYPE.PRIVATE_CONTENTS_AND_MOVABLES',
                value: 'PRIVATE_CONTENTS_AND_MOVABLES'
              },
              {
                key: 'PROPERTIES_FORM.SELECT_LIST.CONTENTS_TYPE.BUSINESS_CONTENTS_AND_MOVABLES',
                value: 'BUSINESS_CONTENTS_AND_MOVABLES'
              },
              {
                key: 'PROPERTIES_FORM.SELECT_LIST.CONTENTS_TYPE.GARAGE_OUTBUILDING_CONTENTS',
                value: 'GARAGE_OUTBUILDING_CONTENTS'
              },
              {
                key: 'PROPERTIES_FORM.SELECT_LIST.CONTENTS_TYPE.OWN_FITTINGS',
                value: 'OWN_FITTINGS'
              },
              {
                key: 'PROPERTIES_FORM.SELECT_LIST.CONTENTS_TYPE.STORED_CONTENTS',
                value: 'STORED_CONTENTS'
              },
              {
                key: 'PROPERTIES_FORM.SELECT_LIST.CONTENTS_TYPE.FARM_MOVABLES_AND_DISCONTINUED_FARM',
                value: 'FARM_MOVABLES_AND_DISCONTINUED_FARM'
              },
            ]
          }
        },
      ]
    },
    {
      name: 'houseAdditionalBuildings', key: 'HOUSE_ADDITIONAL_BUILDINGS', group: 'OBJECT_INFO',
      values: [
        {
          name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.STANDARD', value: 'STANDARD' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.SUPER', value: 'SUPER' }
            ]
          }
        },
        {
          name: 'houseBuildingMaterials', key: 'BUILDING_MATERIALS', group: 'OBJECT_INFO',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MATERIALS.WOOD', value: 'WOOD' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MATERIALS.CONCRETE', value: 'CONCRETE' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.BUILDING_MATERIALS.MUR_AND_WOOD', value: 'MUR_AND_WOOD' },
            ]
          }
        },
        {
          name: 'houseSquareMeters', key: 'SQUARE_METERS', group: 'OBJECT_INFO',
          inputType: INPUT_TYPES_CONFIG.NUMBER,
          validator: ['', [
            Validators.required
          ]]
        },
        {
          name: 'houseBuildingYear', key: 'BUILDING_YEAR', group: 'OBJECT_INFO',
          inputType: INPUT_TYPES_CONFIG.DATE,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            dateView: 'multi-years'
          }
        },
        { name: 'houseStandardCategory', key: 'HOUSE_STANDARD_CATEGORY', group: 'INSURANCE_INFO',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_STANDARD_CATEGORY.NORMAL', value: 'NORMAL' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_STANDARD_CATEGORY.BETTER', value: 'BETTER' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_STANDARD_CATEGORY.STANDARD', value: 'STANDARD' }
            ]
          }
        },
        {
          name: 'houseSumInsuredType',
          key: 'SUM_INSURED_TYPE',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          isFirstRiskSumInsuredCheck: true,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SUM_INSURED_TYPE.FULL_VALUE', value: 'FULL_VALUE' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_SUM_INSURED_TYPE.FIRST_RISK', value: 'FIRST_RISK' },
            ]
          }
        },
        { name: 'houseFirstRiskSumInsured', key: 'SUM_INSURED', group: 'INSURANCE_INFO' },
        {
          name: 'houseBuildingHasWater', key: 'HOUSE_BUILDING_HAS_WATER', group: 'OBJECT_INFO',
          inputType: INPUT_TYPES_CONFIG.BOOLEAN,
          validator: ['', [
            Validators.required
          ]]
        },
        { name: 'houseBuildingType', key: 'BUILDING_TYPE', group: 'OBJECT_INFO',
          inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
          validator: ['', [
            Validators.required
          ]],
          settings: {
            list: [
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.CARPORT', value: 'CARPORT' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.GARAGE_NOT_ISOLATED', value: 'GARAGE_NOT_ISOLATED' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.GARAGE_ISOLATED', value: 'GARAGE_ISOLATED' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.ROW_GARAGE', value: 'ROW_GARAGE' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.LOGCABIN_NOT_ISOLATED', value: 'LOGCABIN_NOT_ISOLATED' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.LOGCABIN_MACHINE', value: 'LOGCABIN_MACHINE' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.LOGCABIN_BY_HAND', value: 'LOGCABIN_BY_HAND' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.SHED_NOT_ISOLATED', value: 'SHED_NOT_ISOLATED' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.SHED_ISOLATED', value: 'SHED_ISOLATED' },
              { key: 'PROPERTIES_FORM.SELECT_LIST.HOUSE_BUILDING_TYPE.BATH_HOUSE', value: 'BATH_HOUSE' },
            ]
          }
        },
      ]
    }
  ],
  icon:'vacation-home'
};
